module.exports = __webpack_public_path__ + "static/media/t06kz.2a678023.pdf";